module.exports = __webpack_public_path__ + "img/campanas-de-vidrio2.4fa7bd78.png";